import s, { css } from "styled-components";
import BaseModal from "_c/Modals/base-modal";
import { CircleButton } from "_c/button";
import { motion } from "framer-motion";

const slideLoadingMixin = css`
  width: auto;
  height: auto;
  width: 100px;
  height: auto;
  position: absolute;
  left: calc(50% - 50px);
  top: calc(50% - 23px);
`;
const slideReadyMixin = css`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  left: 0;
  top: 0;
`;
export const breakPoints = {
  desktop: {
    asideWidth: "330px",
    size: "600px",
  },
  lg: {
    bp: "1100px",
    asideWidth: "220px",
    size: "500px",
  },
  md: {
    bp: "840px",
    asideWidth: "220px",
    size: "320px",
  },
  sm: {
    bp: "600px",
  },
};
export const Modal = s(BaseModal).attrs({
  id: "portfolio-gallery",
})`
  overflow-y: auto;
  transform: none !important;
  left: 0 !important;
  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  display: flex;
  position: fixed !important;
  @media(max-width: ${breakPoints.sm.bp}) {
    background-color: var(--bg-paper);
  }
`;
export const CloseOverlay = s.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  @media(max-width: ${breakPoints.sm.bp}) {
    background-color: var(--bg-paper);
  }
`;
export const InnerWrap = s.div`
  position: relative;
  display: flex;
  margin: auto auto;
  @media(max-width: ${breakPoints.sm.bp}) {
    background-color: var(--bg-paper);
    flex-direction: column;
    width: 100%;
    margin: 0;
  }
`;
export const CloseButton = s.button`
  position: fixed;
  right: 40px;
  top: 25px;
  padding: 0;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity .35s ease;
  z-index: 3;
  img {
    width: 20px;
  }
  &:hover {
    opacity: .7;
  }
  @media(max-width: ${breakPoints.sm.bp}) {
    display: none;
  }
`;
export const MobileCloseButton = s.button`
  display: none;
  @media(max-width: ${breakPoints.sm.bp}) {
    background-color: var(--bg-paper);
    font-weight: 400;
    color: var(--font-color-main);
    padding: 10px;
    z-index: 5;
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
  }
`;
export const SliderWrap = s.div`
  width: ${breakPoints.desktop.size};
  height: ${breakPoints.desktop.size};
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  @media(max-width: ${breakPoints.lg.bp}) {
    width: ${breakPoints.lg.size};
    height: ${breakPoints.lg.size};
  }
  @media(max-width: ${breakPoints.md.bp}) {
    width: ${breakPoints.md.size};
    height: ${breakPoints.md.size};
  }
  @media(max-width: ${breakPoints.sm.bp}) {
    width: 100%;
    margin-top: 38px;
    position: relative;
    padding-bottom: 100%;
  }
`;
export const NavButton = s(CircleButton).attrs({
  medium: true,
})`
  margin: auto 15px;
  @media(max-width: 700px) {
    display: none;
  }
`;
export const LeftNavButton = s(NavButton)`
  img {
    padding-right: 1px;
  }
`;
export const RightNavButton = s(NavButton)`
  img {
    padding-left: 3px;
  }
`;
export const Slide = motion(s.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  display: block;
  user-drag: none;
  @media(max-width: ${breakPoints.sm.bp}) {
    ${({ isLoading }) => (isLoading ? slideLoadingMixin : slideReadyMixin)}
  }
`);
